/**
 * PDFSectionsToggle Component
 * Checkboxes to toggle which sections to include in PDF export
 * Extracted from QuotationEditorModal.jsx
 */
import React from "react";
import { FileText } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Checkbox } from "@/components/ui/checkbox";

const PDFSectionsToggle = ({
  showSupply,
  setShowSupply,
  showFreight,
  setShowFreight,
  showInstallation,
  setShowInstallation,
  showPdr,
  setShowPdr,
  showOtros,
  setShowOtros
}) => {
  return (
    <Card className="border-slate-200">
      <CardHeader className="py-3">
        <CardTitle className="text-sm flex items-center gap-2">
          <FileText className="w-4 h-4" />
          Secciones a Incluir en PDF
        </CardTitle>
        <CardDescription className="text-xs">
          Desmarca las secciones que no deseas incluir en la cotización
        </CardDescription>
      </CardHeader>
      <CardContent className="py-2">
        <div className="grid grid-cols-2 gap-3">
          <div className="flex items-center space-x-2">
            <Checkbox 
              id="show-supply" 
              checked={showSupply} 
              onCheckedChange={setShowSupply}
              data-testid="checkbox-supply"
            />
            <label htmlFor="show-supply" className="text-sm font-medium cursor-pointer">
              Suministro
            </label>
          </div>
          <div className="flex items-center space-x-2">
            <Checkbox 
              id="show-freight" 
              checked={showFreight} 
              onCheckedChange={setShowFreight}
              data-testid="checkbox-freight"
            />
            <label htmlFor="show-freight" className="text-sm font-medium cursor-pointer">
              Flete Internacional
            </label>
          </div>
          <div className="flex items-center space-x-2">
            <Checkbox 
              id="show-installation" 
              checked={showInstallation} 
              onCheckedChange={setShowInstallation}
              data-testid="checkbox-installation"
            />
            <label htmlFor="show-installation" className="text-sm font-medium cursor-pointer">
              Instalación
            </label>
          </div>
          <div className="flex items-center space-x-2">
            <Checkbox 
              id="show-pdr" 
              checked={showPdr} 
              onCheckedChange={setShowPdr}
              data-testid="checkbox-pdr"
            />
            <label htmlFor="show-pdr" className="text-sm font-medium cursor-pointer">
              PDR
            </label>
          </div>
          <div className="flex items-center space-x-2">
            <Checkbox 
              id="show-otros" 
              checked={showOtros} 
              onCheckedChange={setShowOtros}
              data-testid="checkbox-otros"
            />
            <label htmlFor="show-otros" className="text-sm font-medium cursor-pointer">
              Otros
            </label>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default PDFSectionsToggle;
